// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "filter_order.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "filter_order.proto" (syntax proto3)
// tslint:disable
import { Empty } from "./common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
// @generated message type with reflection information, may provide speed optimized methods
class FilterOrder$Type extends MessageType {
    constructor() {
        super("FilterOrder", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 35, name: "status_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "line_items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FilterOrderLineItem },
            { no: 5, name: "included_with_visit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "paid_for", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "is_adhoc", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "delivery_location", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "cost", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "order_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 36, name: "tracking_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "eta", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "created_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "date_created", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "date_updated", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "pm_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "event_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "event_job_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "membership_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 21, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 22, name: "property_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "property_city", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "customer_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 25, name: "customer_firstname", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 26, name: "customer_lastname", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 27, name: "customer_businessname", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 28, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 29, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 30, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 31, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 32, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 33, name: "status_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 34, name: "with_line_items", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.eventId = 0;
        message.statusId = 0;
        message.status = "";
        message.lineItems = [];
        message.includedWithVisit = false;
        message.paidFor = false;
        message.isAdhoc = false;
        message.deliveryLocation = "";
        message.cost = 0;
        message.orderNumber = "";
        message.trackingNumber = "";
        message.eta = "";
        message.notes = "";
        message.isActive = false;
        message.createdBy = 0;
        message.dateCreated = "";
        message.dateUpdated = "";
        message.pmDate = "";
        message.eventStatus = "";
        message.eventJobNumber = "";
        message.membershipId = 0;
        message.propertyId = 0;
        message.propertyAddress = "";
        message.propertyCity = "";
        message.customerId = 0;
        message.customerFirstname = "";
        message.customerLastname = "";
        message.customerBusinessname = "";
        message.fieldMask = [];
        message.orderBy = "";
        message.orderDir = "";
        message.pageNumber = 0;
        message.withoutLimit = false;
        message.statusList = "";
        message.withLineItems = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 event_id */ 2:
                    message.eventId = reader.int32();
                    break;
                case /* int32 status_id */ 35:
                    message.statusId = reader.int32();
                    break;
                case /* string status */ 3:
                    message.status = reader.string();
                    break;
                case /* repeated FilterOrderLineItem line_items */ 4:
                    message.lineItems.push(FilterOrderLineItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool included_with_visit */ 5:
                    message.includedWithVisit = reader.bool();
                    break;
                case /* bool paid_for */ 6:
                    message.paidFor = reader.bool();
                    break;
                case /* bool is_adhoc */ 7:
                    message.isAdhoc = reader.bool();
                    break;
                case /* string delivery_location */ 8:
                    message.deliveryLocation = reader.string();
                    break;
                case /* double cost */ 9:
                    message.cost = reader.double();
                    break;
                case /* string order_number */ 10:
                    message.orderNumber = reader.string();
                    break;
                case /* string tracking_number */ 36:
                    message.trackingNumber = reader.string();
                    break;
                case /* string eta */ 11:
                    message.eta = reader.string();
                    break;
                case /* string notes */ 12:
                    message.notes = reader.string();
                    break;
                case /* bool is_active */ 13:
                    message.isActive = reader.bool();
                    break;
                case /* int32 created_by */ 14:
                    message.createdBy = reader.int32();
                    break;
                case /* string date_created */ 15:
                    message.dateCreated = reader.string();
                    break;
                case /* string date_updated */ 16:
                    message.dateUpdated = reader.string();
                    break;
                case /* string pm_date */ 17:
                    message.pmDate = reader.string();
                    break;
                case /* string event_status */ 18:
                    message.eventStatus = reader.string();
                    break;
                case /* string event_job_number */ 19:
                    message.eventJobNumber = reader.string();
                    break;
                case /* int32 membership_id */ 20:
                    message.membershipId = reader.int32();
                    break;
                case /* int32 property_id */ 21:
                    message.propertyId = reader.int32();
                    break;
                case /* string property_address */ 22:
                    message.propertyAddress = reader.string();
                    break;
                case /* string property_city */ 23:
                    message.propertyCity = reader.string();
                    break;
                case /* int32 customer_id */ 24:
                    message.customerId = reader.int32();
                    break;
                case /* string customer_firstname */ 25:
                    message.customerFirstname = reader.string();
                    break;
                case /* string customer_lastname */ 26:
                    message.customerLastname = reader.string();
                    break;
                case /* string customer_businessname */ 27:
                    message.customerBusinessname = reader.string();
                    break;
                case /* repeated string field_mask */ 28:
                    message.fieldMask.push(reader.string());
                    break;
                case /* string order_by */ 29:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 30:
                    message.orderDir = reader.string();
                    break;
                case /* int32 page_number */ 31:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 32:
                    message.withoutLimit = reader.bool();
                    break;
                case /* string status_list */ 33:
                    message.statusList = reader.string();
                    break;
                case /* bool with_line_items */ 34:
                    message.withLineItems = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 event_id = 2; */
        if (message.eventId !== 0)
            writer.tag(2, WireType.Varint).int32(message.eventId);
        /* string status = 3; */
        if (message.status !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.status);
        /* repeated FilterOrderLineItem line_items = 4; */
        for (let i = 0; i < message.lineItems.length; i++)
            FilterOrderLineItem.internalBinaryWrite(message.lineItems[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool included_with_visit = 5; */
        if (message.includedWithVisit !== false)
            writer.tag(5, WireType.Varint).bool(message.includedWithVisit);
        /* bool paid_for = 6; */
        if (message.paidFor !== false)
            writer.tag(6, WireType.Varint).bool(message.paidFor);
        /* bool is_adhoc = 7; */
        if (message.isAdhoc !== false)
            writer.tag(7, WireType.Varint).bool(message.isAdhoc);
        /* string delivery_location = 8; */
        if (message.deliveryLocation !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.deliveryLocation);
        /* double cost = 9; */
        if (message.cost !== 0)
            writer.tag(9, WireType.Bit64).double(message.cost);
        /* string order_number = 10; */
        if (message.orderNumber !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.orderNumber);
        /* string eta = 11; */
        if (message.eta !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.eta);
        /* string notes = 12; */
        if (message.notes !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.notes);
        /* bool is_active = 13; */
        if (message.isActive !== false)
            writer.tag(13, WireType.Varint).bool(message.isActive);
        /* int32 created_by = 14; */
        if (message.createdBy !== 0)
            writer.tag(14, WireType.Varint).int32(message.createdBy);
        /* string date_created = 15; */
        if (message.dateCreated !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.dateCreated);
        /* string date_updated = 16; */
        if (message.dateUpdated !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.dateUpdated);
        /* string pm_date = 17; */
        if (message.pmDate !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.pmDate);
        /* string event_status = 18; */
        if (message.eventStatus !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.eventStatus);
        /* string event_job_number = 19; */
        if (message.eventJobNumber !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.eventJobNumber);
        /* int32 membership_id = 20; */
        if (message.membershipId !== 0)
            writer.tag(20, WireType.Varint).int32(message.membershipId);
        /* int32 property_id = 21; */
        if (message.propertyId !== 0)
            writer.tag(21, WireType.Varint).int32(message.propertyId);
        /* string property_address = 22; */
        if (message.propertyAddress !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.propertyAddress);
        /* string property_city = 23; */
        if (message.propertyCity !== "")
            writer.tag(23, WireType.LengthDelimited).string(message.propertyCity);
        /* int32 customer_id = 24; */
        if (message.customerId !== 0)
            writer.tag(24, WireType.Varint).int32(message.customerId);
        /* string customer_firstname = 25; */
        if (message.customerFirstname !== "")
            writer.tag(25, WireType.LengthDelimited).string(message.customerFirstname);
        /* string customer_lastname = 26; */
        if (message.customerLastname !== "")
            writer.tag(26, WireType.LengthDelimited).string(message.customerLastname);
        /* string customer_businessname = 27; */
        if (message.customerBusinessname !== "")
            writer.tag(27, WireType.LengthDelimited).string(message.customerBusinessname);
        /* repeated string field_mask = 28; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(28, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* string order_by = 29; */
        if (message.orderBy !== "")
            writer.tag(29, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 30; */
        if (message.orderDir !== "")
            writer.tag(30, WireType.LengthDelimited).string(message.orderDir);
        /* int32 page_number = 31; */
        if (message.pageNumber !== 0)
            writer.tag(31, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 32; */
        if (message.withoutLimit !== false)
            writer.tag(32, WireType.Varint).bool(message.withoutLimit);
        /* string status_list = 33; */
        if (message.statusList !== "")
            writer.tag(33, WireType.LengthDelimited).string(message.statusList);
        /* bool with_line_items = 34; */
        if (message.withLineItems !== false)
            writer.tag(34, WireType.Varint).bool(message.withLineItems);
        /* int32 status_id = 35; */
        if (message.statusId !== 0)
            writer.tag(35, WireType.Varint).int32(message.statusId);
        /* string tracking_number = 36; */
        if (message.trackingNumber !== "")
            writer.tag(36, WireType.LengthDelimited).string(message.trackingNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FilterOrder
 */
export const FilterOrder = new FilterOrder$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FilterOrderLineItem$Type extends MessageType {
    constructor() {
        super("FilterOrderLineItem", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "filter_order_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "size", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "quantity", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "part_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "vendor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "date_created", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "filter_order_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.filterOrderId = 0;
        message.size = "";
        message.quantity = 0;
        message.partNumber = "";
        message.vendor = "";
        message.dateCreated = "";
        message.fieldMask = [];
        message.filterOrderIdList = "";
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 filter_order_id */ 2:
                    message.filterOrderId = reader.int32();
                    break;
                case /* string size */ 3:
                    message.size = reader.string();
                    break;
                case /* int32 quantity */ 4:
                    message.quantity = reader.int32();
                    break;
                case /* string part_number */ 5:
                    message.partNumber = reader.string();
                    break;
                case /* string vendor */ 6:
                    message.vendor = reader.string();
                    break;
                case /* string date_created */ 7:
                    message.dateCreated = reader.string();
                    break;
                case /* repeated string field_mask */ 8:
                    message.fieldMask.push(reader.string());
                    break;
                case /* string filter_order_id_list */ 9:
                    message.filterOrderIdList = reader.string();
                    break;
                case /* bool without_limit */ 10:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 filter_order_id = 2; */
        if (message.filterOrderId !== 0)
            writer.tag(2, WireType.Varint).int32(message.filterOrderId);
        /* string size = 3; */
        if (message.size !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.size);
        /* int32 quantity = 4; */
        if (message.quantity !== 0)
            writer.tag(4, WireType.Varint).int32(message.quantity);
        /* string part_number = 5; */
        if (message.partNumber !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.partNumber);
        /* string vendor = 6; */
        if (message.vendor !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.vendor);
        /* string date_created = 7; */
        if (message.dateCreated !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.dateCreated);
        /* repeated string field_mask = 8; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* string filter_order_id_list = 9; */
        if (message.filterOrderIdList !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.filterOrderIdList);
        /* bool without_limit = 10; */
        if (message.withoutLimit !== false)
            writer.tag(10, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FilterOrderLineItem
 */
export const FilterOrderLineItem = new FilterOrderLineItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FilterOrderList$Type extends MessageType {
    constructor() {
        super("FilterOrderList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FilterOrder },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated FilterOrder results */ 1:
                    message.results.push(FilterOrder.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated FilterOrder results = 1; */
        for (let i = 0; i < message.results.length; i++)
            FilterOrder.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FilterOrderList
 */
export const FilterOrderList = new FilterOrderList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FilterOrderStatusCounts$Type extends MessageType {
    constructor() {
        super("FilterOrderStatusCounts", [
            { no: 1, name: "needs_ordered", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "ordered", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "delivered", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "completed", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.needsOrdered = 0;
        message.ordered = 0;
        message.delivered = 0;
        message.completed = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 needs_ordered */ 1:
                    message.needsOrdered = reader.int32();
                    break;
                case /* int32 ordered */ 2:
                    message.ordered = reader.int32();
                    break;
                case /* int32 delivered */ 3:
                    message.delivered = reader.int32();
                    break;
                case /* int32 completed */ 4:
                    message.completed = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 needs_ordered = 1; */
        if (message.needsOrdered !== 0)
            writer.tag(1, WireType.Varint).int32(message.needsOrdered);
        /* int32 ordered = 2; */
        if (message.ordered !== 0)
            writer.tag(2, WireType.Varint).int32(message.ordered);
        /* int32 delivered = 3; */
        if (message.delivered !== 0)
            writer.tag(3, WireType.Varint).int32(message.delivered);
        /* int32 completed = 4; */
        if (message.completed !== 0)
            writer.tag(4, WireType.Varint).int32(message.completed);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FilterOrderStatusCounts
 */
export const FilterOrderStatusCounts = new FilterOrderStatusCounts$Type();
/**
 * @generated ServiceType for protobuf service FilterOrderService
 */
export const FilterOrderService = new ServiceType("FilterOrderService", [
    { name: "Create", options: {}, I: FilterOrder, O: FilterOrder },
    { name: "Get", options: {}, I: FilterOrder, O: FilterOrder },
    { name: "BatchGet", options: {}, I: FilterOrder, O: FilterOrderList },
    { name: "Update", options: {}, I: FilterOrder, O: FilterOrder },
    { name: "Delete", options: {}, I: FilterOrder, O: Empty },
    { name: "UpdateFilterOrderLineItem", options: {}, I: FilterOrderLineItem, O: FilterOrderLineItem },
    { name: "GetFilterOrderStatusCounts", options: {}, I: FilterOrder, O: FilterOrderStatusCounts }
]);
